<template>
  <el-row>
    <el-col>
      <div class="toolbar-row">
        <div class="toolbar-search">
          <!-- <rabbey-toolbox 
                        :filterables="true" 
                        @filter-search="search = $event">
                    </rabbey-toolbox> -->
        </div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          class="new-doc-btn"
          :loading="isCreatingDocument"
          :disabled="isCreatingDocument || openAdd"
          @click="onAddDocument"
        >
          Nuevo
        </el-button>
      </div>
      <rabbey-table3
        ref="table"
        :data="documentsList"
        :columns="columns"
        :search="search"
        :actions="actions"
        :loading="loading"
        :page_Size="pageSize"
        :pageSizes="pageSizes"
        @rtable-push-action="actionHandler"
        @update-page-size="updatePageSize"
      />
    </el-col>

    <el-drawer
      :title="title"
      :visible.sync="openAdd"
      direction="rtl"
      size="29%"
      @opened="onDrawerOpened"
      @closed="onDrawerClosed"
    >
      <div
        class="flex gaps column demo-drawer__content border-myborder"
        style="padding: 20px"
      >
        <div id="div-legal">
          <CreateDocument
            class="scrollable"
            style="max-height: 800px"
            :Visible="openAdd"
            ref="myDocument"
            :IsPersonal="true"
            @dialog-closed="onDialogClosed"
            @success="getTableData"
          ></CreateDocument>
        </div>
      </div>
    </el-drawer>
  </el-row>
</template>

<script>
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ArchiveDownloadLink from "@/components/functionals/ArchiveDownloadLink.vue";
import CreateDocument from "@/components/Documents/CreateDocument.vue";

export default {
  name: "MisDocuments",
  components: {
    CreateDocument
  },
  data() {
    return {
      openAdd: false,
      isCreatingDocument: false,
      title: "Agregar nuevo documento",
      search: "",
      loading: false,
      pageSize: 10,
      pageSizes: [10, 20, 50, 100, 500],
      documentsList: [],
      actions: [
        {
          icon: "el-icon-delete",
          label: "Eliminar",
          command: "delete"
        }
      ],
      columns: [
        {
          prop: "Id",
          label: "NO",
          width: 80,
          sortable: true
        },
        {
          prop: "NameArchive",
          label: "Nombre del archivo",
          sortable: true,
          formatter: ArchiveDownloadLink
        },
        {
          prop: "DescriptionArchive",
          label: "Descripcion",
          sortable: true
        },
        {
          prop: "CreatedAt",
          label: "Fecha de creacion",
          sortable: true,
          formatter: DatetimeFormatter
        }
      ]
    };
  },
  methods: {
    actionHandler(action) {
      if (!action || action.command !== "delete") return;

      const currentUser = this.$store.state.user.user;
      const loggedEmployeeId = currentUser.EmployeeId;
      const row = action.row || {};
      const fileId = row.Id;

      if (!fileId) {
        this.$message.error("No se pudo identificar el documento a eliminar");
        return;
      }

      this.$confirm("Segura/o que desea eliminar este registro ?")
        .then(() => {
          this.deleteFile(fileId, loggedEmployeeId);
        })
        .catch(() => {});
    },
    deleteFile(fileId, employeeId) {
      this.loading = true;
      this.$http
        .put(`/api/Folder/DeleteDoc?docId=${fileId}&employeeId=${employeeId}`)
        .then(() => {
          this.$message.success("Documento eliminado correctamente");
          this.getTableData();
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    onAddDocument() {
      if (this.isCreatingDocument || this.openAdd) return;

      this.isCreatingDocument = true;
      this.openAdd = true;
    },
    onDrawerOpened() {
      this.isCreatingDocument = false;
    },
    onDrawerClosed() {
      this.openAdd = false;
      this.isCreatingDocument = false;
    },
    onDialogClosed() {
      this.openAdd = false;
      this.isCreatingDocument = false;
    },
    getTableData() {
      this.loading = true;
      this.documentsList = [];
      const currentUser = this.$store.state.user.user;
      const employeeId = currentUser.EmployeeId;
      const isPersonal = true;

      this.$http
        .get(
          `/api/Folder/GetMyDocuments?employeeId=${employeeId}&IsPersonal=${isPersonal}&ByGen=0`
        )
        .then((response) => {
          this.documentsList = Array.isArray(response.data)
            ? response.data
            : [];
        })
        .catch(() => {
          this.documentsList = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updatePageSize(value) {
      this.pageSize = value;
    }
  },
  mounted() {
    this.getTableData();
  }
};
</script>

<style scoped>
.toolbar-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 12px;
}

.toolbar-search {
  flex: 1;
}

.toolbar-search :deep(.mb-10) {
  margin-bottom: 0 !important;
}

.new-doc-btn {
  height: 28px;
  padding: 0 10px;
}
</style>
